module.exports = __webpack_public_path__ + "static/media/ss4.6ee4f828.jpg";